//This Page is reponsible for the Technician Panel Patient enrollment
/* eslint-disable */
import React, { useState, useRef, useEffect,useMemo } from "react";
import { db, storage } from "../../firebase-config";
import { ref as dbRef, set, get, onValue } from "firebase/database";

// Import audit logging helpers
import { logPatientCreationTech } from "./TechAuditLogs";
import {
  ref as storageRef,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChatNot from "../../components/Chat/ChatNot";
import "../../components/Chat/ChatNot.css";
import "./AddPatientTech.css";
import CryptoJS from "crypto-js";
import { Dropdown } from "react-bootstrap"; // ✅ Import Dropdown
import JSZip from "jszip";
import Select from "react-select";

// Helper function to check if a DICOM file should be excluded from ZIP creation
// Excludes dicom-seg-[1-9].dcm and dicom-sr-[1-9].dcm files
const shouldExcludeFromZip = (filename) => {
  const lowerFilename = filename.toLowerCase();
  
  // Check for dicom-seg-[1-9].dcm pattern
  const dicomSegPattern = /^dicom-seg-[1-9]\.dcm$/;
  if (dicomSegPattern.test(lowerFilename)) {
    return true;
  }
  
  // Check for dicom-sr-[1-9].dcm pattern
  const dicomSrPattern = /^dicom-sr-[1-9]\.dcm$/;
  if (dicomSrPattern.test(lowerFilename)) {
    return true;
  }
  
  return false;
};

// Main Component for Adding Patients and Uploading Files
const AddPatientTech = () => {
  // State variables for form data
  const [fullName, setFullName] = useState("");
  const [role] = useState("Patient");
  const [Id, setID] = useState("");
  const [Dicom3D, setDicom3D] = useState(null);
  const [hodDoctors, setHodDoctors] = useState([]);
  const [assignedHodDoctor, setAssignedHodDoctor] = useState("");
  const [gender, setGender] = useState("");
  const [age, setAge] = useState("");
  const [ageYears, setAgeYears] = useState("");
  const [ageMonths, setAgeMonths] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0); // Track upload percentage
  const [totalBytes, setTotalBytes] = useState(0);
  const [uploadedBytes, setUploadedBytes] = useState(0);
  const [modalIsOpen, setModalIsOpen] = useState(false); // Control modal visibility
  const [selectedDicomFolderFiles, setSelectedDicomFolderFiles] = useState([]);
  const adminName1 = localStorage.getItem("adminName");
  const techname = localStorage.getItem("Name");
  const navigate = useNavigate();

  const [modality, setModality] = useState("XRAY"); // <-- Added modality to state with XRAY as default
  const [selectedReportFile, setSelectedReportFile] = useState(null); // For report upload
  const [clinicalHistoryText, setClinicalHistoryText] = useState(""); // Store clinical history text
  const [clinicalHistoryFile, setClinicalHistoryFile] = useState(null); // Store clinical history file
  const [selectedTest, setSelectedTest] = useState("");

  const [selected3DFileName, setSelected3DFileName] = useState(""); // For 3D file
  const [selectedFolderName, setSelectedFolderName] = useState(""); // For folder
  const [selectedReportFileName, setSelectedReportFileName] = useState(""); // For report file

  const [testType, setTestType] = useState(""); // Final value for the database

  // <<< Wallet integration state >>>
  const [walletBalance, setWalletBalance] = useState(0);
  const [costingType, setCostingType] = useState("");
  const [patientAddFee, setPatientAddFee] = useState(0);

  const file3DInputRef = useRef(null); // Ref for 3D file input
  const folderInputRef = useRef(null); // Ref for folder input
  const reportFileInputRef = useRef(null); // Ref for report file input
  const [canSubmit, setCanSubmit] = useState(false); //Deepa Added for disable until mandatory filled

  // Function to decrypt keys and make them Firebase-safe (decryptData already exists in this file)
  const decryptKey = (encryptedKey) => {
    try {
      const base64String = encryptedKey.replace(/_/g, '/').replace(/-/g, '+');
      const encrypted = atob(base64String);
      return decryptData(encrypted);
    } catch (error) {
      console.warn("AddPatientTech - Key decryption failed, returning original key:", error);
      return encryptedKey;
    }
  };

  // Helper function to get doctor data (handles both encrypted and plain text)
  const getDoctorData = (doctorData, fieldName) => {
    if (!doctorData) return null;
    
    // First try direct field access (for legacy plain text data)
    if (doctorData[fieldName] !== undefined && doctorData[fieldName] !== null) {
      try {
        return decryptData(doctorData[fieldName]);
      } catch (error) {
        return doctorData[fieldName]; // Return as-is if decryption fails
      }
    }
    
    // Then try to find encrypted key version
    for (const key in doctorData) {
      try {
        const decryptedKey = decryptKey(key);
        if (decryptedKey === fieldName) {
          return decryptData(doctorData[key]);
        }
      } catch (error) {
        continue; // Continue to next key if decryption fails
      }
    }
    
    return null;
  };

  // Fetch HOD doctors and assign one automatically
  useEffect(() => {
    const fetchHodDoctors = async () => {
      try {
        console.log("AddPatientTech - Fetching HOD doctors for auto-assignment");
        const doctorsRef = dbRef(db, `superadmin/admins/${adminName1}/doctors`);
        const snapshot = await get(doctorsRef);
        
        if (snapshot.exists()) {
          const doctorsData = snapshot.val();
          const hodDoctorsList = [];
          
          Object.entries(doctorsData).forEach(([doctorId, doctorData]) => {
            // Get decrypted doctor role and name
            const decryptedRole = getDoctorData(doctorData, "Role") || doctorData.Role;
            const decryptedName = getDoctorData(doctorData, "Name") || doctorData.Name;
            
            console.log(`AddPatientTech - Doctor ${doctorId}:`, {
              decryptedName,
              decryptedRole
            });
            
            // Check if doctor has HOD role
            if (decryptedRole === "HOD") {
              hodDoctorsList.push({
                id: doctorId,
                name: decryptedName || "Unknown HOD",
                role: decryptedRole
              });
            }
          });
          
          console.log("AddPatientTech - Found HOD doctors:", hodDoctorsList);
          setHodDoctors(hodDoctorsList);
          
          // Always auto-assign HOD role (regardless of whether HOD doctors exist)
          setAssignedHodDoctor("HOD");
          if (hodDoctorsList.length > 0) {
            console.log("AddPatientTech - Auto-assigned HOD role (HOD doctors exist)");
          } else {
            console.log("AddPatientTech - Auto-assigned HOD role (no HOD doctors exist yet, but future HOD doctors will see this patient)");
          }
        } else {
          console.log("AddPatientTech - No doctors found in database, but still assigning HOD role");
          setHodDoctors([]);
          setAssignedHodDoctor("HOD");
        }
      } catch (error) {
        console.error("AddPatientTech - Error fetching HOD doctors:", error);
        console.log("AddPatientTech - Despite error, still assigning HOD role for future compatibility");
        setHodDoctors([]);
        setAssignedHodDoctor("HOD");
      }
    };

    if (adminName1) {
      fetchHodDoctors();
    }
  }, [adminName1]);

  // Viniith Fix this 05-08-2025 - Use useMemo to prevent button flickering + modality validation
  const canSubmitValue = useMemo(() => {
    const validName = fullName.trim() !== "" && !/\d/.test(fullName);
    const validAge = ageYears.trim() !== "";
    const validGender = gender.trim() !== "";
    const validID = Id.trim() !== "";
    
    // Viniith Fix this 05-08-2025 - Modality/Category/Test Type validation
    let validModalityFlow = true;
    if (modality.trim() !== "") {
      // If modality is selected, category must be selected
      if (selectedTest.trim() === "" || selectedTest === "Test Type") {
        validModalityFlow = false;
      }
      // If category is selected and it's "Other", custom test type must be filled
      else if (selectedTest === "Other" && testType.trim() === "") {
        validModalityFlow = false;
      }
      // If category is selected and it's not "Other", testType should be set
      else if (selectedTest !== "Other" && testType.trim() === "") {
        validModalityFlow = false;
      }
    }
    
    return validName && validAge && validGender && validID && validModalityFlow;
  }, [fullName, ageYears, gender, Id, modality, selectedTest, testType]);

  // Update canSubmit state only when the computed value actually changes
  useEffect(() => {
    setCanSubmit(canSubmitValue);
  }, [canSubmitValue]);

  // Test names categorized by modality
  const testNames = {
    CT: [
      "CRANIAL PLAIN",
      "CHEST PLAIN & CONTRAST",
      "CERVICAL SPINE PLAIN",
      "CERVICAL SPINE WITH CONTRAST",
      "CHEST HR PLAIN",
    ],
    MRI: [
      "BRAIN PLAIN",
      "BRAIN WITH CONTRAST",
      "CERVICAL SPINE PLAIN",
      "CERVICAL SPINE WITH CONTRAST",
      "ABDOMEN PLAIN",
    ],
    XRAY: [
      "CHEST PA VIEW",
      "CHEST AP VIEW",
      "ABDOMEN ERECT",
      "CERVICAL SPINE AP/LAT",
      "PELVIS AP",
    ],
  };
  // Utility function to sanitize Firebase keys (replace invalid characters)
  // Encryption utility using CryptoJS
  const encryptData = (data) => {
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    if (!secretKey) {
      throw new Error("Secret key is not defined");
    }
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  };

  // Decryption utility using CryptoJS
  const decryptData = (encryptedData) => {
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return decryptedData;
    } catch (error) {
      console.warn("AddPatientTech - Decryption failed, returning original data:", error);
      return encryptedData;
    }
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based, so add 1
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
  };

  const notifySuccess = (message) =>
    toast.success(message, { position: "top-center" });

  const notifyError = (message) =>
    toast.error(message, { position: "top-center" });

  // Helper function to reset progress state
  const resetProgressState = () => {
    setUploadProgress(0);
    setTotalBytes(0);
    setUploadedBytes(0);
  };

  // Helper function to calculate total bytes for all uploads
  const calculateTotalUploadBytes = () => {
    let total = 0;
    
    // Add 3D file size
    if (Dicom3D) {
      total += Dicom3D.size;
    }
    
    // Add report file size
    if (selectedReportFile) {
      total += selectedReportFile.size;
    }
    
    // Add clinical history file size
    if (clinicalHistoryFile) {
      total += clinicalHistoryFile.size;
    }
    
    // Add DICOM folder files size (only original files, ZIP is handled separately)
    if (selectedDicomFolderFiles && selectedDicomFolderFiles.length > 0) {
      const dicomFolderSize = selectedDicomFolderFiles.reduce((sum, file) => sum + file.size, 0);
      total += dicomFolderSize;
      // Don't add ZIP size here - it's handled in the upload function
    }
    
    return total;
  };

  // <<< Wallet Integration: Fetch wallet balance >>>
  useEffect(() => {
    if (adminName1) {
      const walletBalanceRef = dbRef(
        db,
        `superadmin/admins/${adminName1}/Wallet/Wallet_Balance`
      );
      const unsubscribe = onValue(
        walletBalanceRef,
        (snapshot) => {
          if (snapshot.exists()) {
            setWalletBalance(snapshot.val());
          }
        },
        (error) => {
          // Error listening to wallet balance updates
        }
      );
      return () => unsubscribe();
    }
  }, [adminName1]);

  // <<< Wallet Integration: Fetch costing details >>>
  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const adminRef = dbRef(db, `superadmin/admins/${adminName1}`);
        const snapshot = await get(adminRef);
        if (snapshot.exists()) {
          const adminData = snapshot.val();
          setCostingType(adminData.CostingType || "");
          setPatientAddFee(adminData.costing?.PatientAddFee || 0);
        }
      } catch (error) {
        // Failed to fetch admin data
      }
    };
    if (adminName1) {
      fetchAdminData();
    }
  }, [adminName1]);

  // File validation for 3D files (only .gltf or .glb allowed)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (
      !file.name.toLowerCase().endsWith(".gltf") &&
      !file.name.toLowerCase().endsWith(".glb")
    ) {
      notifyError("Invalid file type. Please upload a .gltf or .glb file.");
      e.target.value = ""; // Clear the file input
      return;
    }
    setDicom3D(file);
    setSelected3DFileName(file.name); // Set selected file name
  };

  const removeDicom3DFile = () => {
    setDicom3D(null); // Clear the selected file
    setSelected3DFileName(""); // Clear the displayed file name
    if (file3DInputRef.current) {
      file3DInputRef.current.value = ""; // Reset the input field
    }
  };

  // Function to validate selected DICOM folder
  // Function to handle single scan image file upload (PNG, JPG, JPEG only)
  const handleSingleScanFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files || files.length === 0) {
      return;
    }

    const isValidFile = (file) => {
      const lowerName = file.name.toLowerCase();
      return (
        lowerName.endsWith(".png") ||
        lowerName.endsWith(".jpg") ||
        lowerName.endsWith(".jpeg") ||
        lowerName.endsWith(".dcm")
      );
    };

    const allValid = files.every(isValidFile);
    if (!allValid) {
      notifyError(
        "Invalid file type. Only PNG (.png), JPEG (.jpg/.jpeg), and DICOM (.dcm) files are allowed"
      );
      e.target.value = "";
      return;
    }

    const isFolder = files[0].webkitRelativePath && files[0].webkitRelativePath.includes("/");
    setSelectedDicomFolderFiles(files);
    setSelectedFolderName(isFolder ? files[0].webkitRelativePath.split("/")[0] : files[0].name);
    console.log("Scan files selected:", files);
  };

  const removeDicomFolder = () => {
    setSelectedDicomFolderFiles([]); // Clear the selected files
    setSelectedFolderName(""); // Clear the folder name
    if (folderInputRef.current) {
      folderInputRef.current.value = ""; // Reset the input field
    }
  };

  // Handle report file validation and selection
  const handleReportFileChange = (e) => {
    const file = e.target.files[0];
    const allowedExtensions = /(\.pdf|\.docx|\.txt)$/i; // Allow only specific extensions
    if (!allowedExtensions.test(file.name.toLowerCase())) {
      notifyError(
        "Invalid file type. Please upload a .pdf, .docx, or .txt file."
      );
      e.target.value = ""; // Clear the file input
      return;
    }
    setSelectedReportFile(file); // Set selected report file
    setSelectedReportFileName(file.name); // Set selected file name
  };

  const removeReportFile = () => {
    setSelectedReportFile(null); // Clear the selected file
    setSelectedReportFileName(""); // Clear the displayed file name
    if (reportFileInputRef.current) {
      reportFileInputRef.current.value = ""; // Reset the input field
    }
  };

  // Upload DICOM 3D file
  const uploadDicom3DFile = async (patientKey) => {
    if (!Dicom3D) {
      return { filePath: "", downloadURL: "" }; // No file selected
    }
    const filePath = `superadmin/admins/${adminName1}/patients/${patientKey}/${Dicom3D.name}`;
    const fileRef = storageRef(storage, filePath);
    const uploadTask = uploadBytesResumable(fileRef, Dicom3D);

    // setUploadProgress(0); // Reset progress
    // setModalIsOpen(true); // Show the upload modal

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadProgress(Math.floor(progress));
        },
        (error) => {
          reject(error);
        },
        async () => {
          try {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            setUploadProgress(100); // For Progress Bar: Set to 100% on completion
            resolve({ filePath, downloadURL });
          } catch (error) {
            reject(error);
          }
        }
      );
    });
  };

  // Upload report file
  const uploadReportFile = async (patientKey) => {
    if (!selectedReportFile) {
      return { filePath: "", downloadURL: "" }; // No file selected
    }
    const filePath = `superadmin/admins/${adminName1}/patients/${patientKey}/${selectedReportFile.name}`;
    const fileRef = storageRef(storage, filePath);
    const uploadTask = uploadBytesResumable(fileRef, selectedReportFile);

    setModalIsOpen(true); // Show the upload modal
    setUploadProgress(0); // Reset progress

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadProgress(Math.floor(progress));
        },
        reject,
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve({ filePath, downloadURL });
        }
      );
    });
  };

  // Helper function to check if modality is XRay
  const checkIfXRayModality = (modalityValue) => {
    if (!modalityValue) return false;
    const modalityUpper = modalityValue.toUpperCase().trim();
    return modalityUpper === "XRAY";
  };

  // Upload DICOM folder
  const uploadDicomFolder = async (patientKey) => {
    if (!selectedDicomFolderFiles || selectedDicomFolderFiles.length === 0) {
      return { folderPath: "", filesUploaded: 0, zipFileName: "", zipDownloadURL: "" };
    }

    const startTime = Date.now();
    const folderPath = `superadmin/admins/${adminName1}/patients/${patientKey}/folder_${Date.now()}/`;
    const encryptedFolderPath = encryptData(folderPath);
    
    // Check if this is XRay modality
    const isXRayModality = checkIfXRayModality(modality);
    console.log(`uploadDicomFolder: Modality='${modality}', Is XRay: ${isXRayModality}`);

    try {
      console.log(`uploadDicomFolder: starting. target folderPath=${folderPath}`);
      
      // 🔹 Step 1: Calculate total work (sum of all file sizes only)
      const totalFileBytes = selectedDicomFolderFiles.reduce((sum, file) => sum + file.size, 0);
      
      console.log(`uploadDicomFolder: Total DICOM files size: ${(totalFileBytes / 1024 / 1024).toFixed(2)}MB`);
      
      // Track uploaded bytes across all files
      let currentUploadedBytes = 0;
      const fileProgressMap = new Map(); // Track progress per file
      
      // For XRay: Group files by their parent folder (series)
      let fileUploadPromises;
      
      if (isXRayModality) {
        console.log(`📁 XRay Upload: Organizing files into XRay folder structure`);
        
        // Group files by series (subfolder name)
        const seriesGroups = new Map(); // Map<seriesName, files[]>
        
        selectedDicomFolderFiles.forEach(file => {
          const relative = file.webkitRelativePath || file.name;
          const pathParts = relative.split('/');
          
          // Get series name (parent folder)
          let seriesName = "XRay_Series";
          if (pathParts.length > 2) {
            seriesName = pathParts[1]; // Use second folder as series name
          } else if (pathParts.length > 1) {
            seriesName = pathParts[0]; // Use first folder as series name
          }
          
          if (!seriesGroups.has(seriesName)) {
            seriesGroups.set(seriesName, []);
          }
          seriesGroups.get(seriesName).push(file);
        });
        
        console.log(`📊 Found ${seriesGroups.size} series:`, Array.from(seriesGroups.keys()));
        
        // Upload files with XRay structure
        fileUploadPromises = [];
        let globalIndex = 0;
        
        seriesGroups.forEach((files, seriesName) => {
          console.log(`📂 Processing series '${seriesName}' with ${files.length} files`);
          
          files.forEach((file, seriesIndex) => {
            const idx = globalIndex++;
            const xrayFolderName = `${seriesName}${seriesIndex + 1}`; // e.g., Knee1, Knee2
            const fileName = file.name;
            
            // Create path: folderPath/seriesName/XRay1/file.dcm
            const filePath = `${folderPath}${seriesName}/${xrayFolderName}/${fileName}`;
            
            console.log(`📤 XRay upload: ${fileName} → ${seriesName}/${xrayFolderName}/`);
            
            const fileRef = storageRef(storage, filePath);
            const task = uploadBytesResumable(fileRef, file);
            
            fileProgressMap.set(idx, 0);
            
            const promise = new Promise((resolve, reject) => {
              task.on(
                "state_changed",
                (snap) => {
                  const previousBytes = fileProgressMap.get(idx) || 0;
                  const currentFileBytes = snap.bytesTransferred;
                  const deltaBytes = currentFileBytes - previousBytes;
                  
                  fileProgressMap.set(idx, currentFileBytes);
                  currentUploadedBytes += deltaBytes;
                  
                  const fileUploadPercent = Math.min(60, (currentUploadedBytes / totalFileBytes) * 60);
                  setUploadProgress(Math.floor(fileUploadPercent));
                },
                (err) => {
                  console.error(`XRay upload failed [${fileName}]`, err);
                  reject(err);
                },
                async () => {
                  console.log(`✅ XRay uploaded: ${fileName}`);
                  resolve();
                }
              );
            });
            
            fileUploadPromises.push(promise);
          });
        });
      } else {
        // Regular upload (non-XRay): preserve relative path
        fileUploadPromises = selectedDicomFolderFiles.map((file, idx) => {
          const relative = file.webkitRelativePath || file.name;
          const filePath = `${folderPath}${relative}`;
          const fileRef = storageRef(storage, filePath);
          const task = uploadBytesResumable(fileRef, file);
          
          fileProgressMap.set(idx, 0);

          return new Promise((resolve, reject) => {
            task.on(
              "state_changed",
              (snap) => {
                const previousBytes = fileProgressMap.get(idx) || 0;
                const currentFileBytes = snap.bytesTransferred;
                const deltaBytes = currentFileBytes - previousBytes;
                
                fileProgressMap.set(idx, currentFileBytes);
                currentUploadedBytes += deltaBytes;
                
                const fileUploadPercent = Math.min(60, (currentUploadedBytes / totalFileBytes) * 60);
                setUploadProgress(Math.floor(fileUploadPercent));
              },
              (err) => {
                console.error(`uploadDicomFolder: file upload failed [${relative}]`, err);
                reject(err);
              },
              async () => {
                console.log(`uploadDicomFolder: uploaded file [${relative}]`);
                resolve();
              }
            );
          });
        });
      }

      await Promise.all(fileUploadPromises);

      // 2) Create ZIP using JSZip
      const zip = new JSZip();
      
      // Filter out dicom-seg-[1-9].dcm and dicom-sr-[1-9].dcm files
      const filteredFiles = selectedDicomFolderFiles.filter(file => {
        const filename = file.name;
        const shouldExclude = shouldExcludeFromZip(filename);
        return !shouldExclude;
      });
      
      if (isXRayModality) {
        console.log(`📦 Creating ZIP with XRay structure for ${filteredFiles.length} files`);
        
        // Group files by series for ZIP (same logic as upload)
        const zipSeriesGroups = new Map();
        
        filteredFiles.forEach(file => {
          const relative = file.webkitRelativePath || file.name;
          const pathParts = relative.split('/');
          
          let seriesName = "XRay_Series";
          if (pathParts.length > 2) {
            seriesName = pathParts[1];
          } else if (pathParts.length > 1) {
            seriesName = pathParts[0];
          }
          
          if (!zipSeriesGroups.has(seriesName)) {
            zipSeriesGroups.set(seriesName, []);
          }
          zipSeriesGroups.get(seriesName).push(file);
        });
        
        // Add files to ZIP with XRay structure
        for (const [seriesName, files] of zipSeriesGroups.entries()) {
          for (let seriesIndex = 0; seriesIndex < files.length; seriesIndex++) {
            const file = files[seriesIndex];
            const xrayFolderName = `${seriesName}${seriesIndex + 1}`;
            const fileName = file.name;
            const zipPath = `${seriesName}/${xrayFolderName}/${fileName}`;
            
            try {
              const arrBuff = await file.arrayBuffer();
              zip.file(zipPath, arrBuff);
              console.log(`📦 Added to ZIP: ${zipPath}`);
            } catch (err) {
              console.error(`Error adding ${fileName} to ZIP:`, err);
              throw err;
            }
          }
        }
      } else {
        // Regular ZIP creation (non-XRay): use original relative paths
        for (const file of filteredFiles) {
          const relativePath = file.webkitRelativePath || file.name;
          try {
            const arrBuff = await file.arrayBuffer();
            zip.file(relativePath, arrBuff);
          } catch (err) {
            throw err;
          }
        }
      }

      console.log("uploadDicomFolder: generating zip blob (this can take memory/time)");
      // generateAsync with progress callback
      const zipBlob = await zip.generateAsync(
        { type: "blob", compression: "DEFLATE", compressionOptions: { level: 6 } },
        (metadata) => {
          // 🔹 Step 3: ZIP creation progress (60-90% range)
          const zipProgress = Math.floor(metadata.percent);
          
          // Calculate overall progress: 60-90% for ZIP creation
          const overallPercent = Math.min(90, 60 + (zipProgress * 30) / 100);
          setUploadProgress(Math.floor(overallPercent));
        }
      );

      // 3) Upload the zip - save it one folder back (parent folder) from DICOM files
      const safeFolderName = selectedFolderName ? selectedFolderName.replace(/[\/\\?#\[\]]/g, "_") : `folder_${Date.now()}`;
      const zipFileName = `${safeFolderName}.zip`;
      const innerFolderName = (selectedFolderName || selectedDicomFolderFiles[0]?.webkitRelativePath?.split("/")[0] || `folder_${Date.now()}`)
      
      // Save ZIP one folder back (parent folder) from where DICOM files are stored
      // Example: If DICOM files are at: Folder1/Folder2/Folder3/Folder4/*.dcm
      // Then ZIP will be saved at: Folder1/Folder2/Folder3/file.zip (one folder back)
      // In our case:
      // DICOM files are at: ${folderPath}${innerFolderName}/*.dcm
      // ZIP will be at: ${folderPath}${zipFileName} (one folder back)
      const zipStoragePath = `${folderPath}${zipFileName}`;

      const zipRef = storageRef(storage, zipStoragePath);
      const zipTask = uploadBytesResumable(zipRef, zipBlob);

      // Wait for zip upload completion and track progress
      await new Promise((resolve, reject) => {
        zipTask.on(
          "state_changed",
          (snapshot) => {
            // 🔹 Step 4: ZIP upload progress (90-100% range)
            const zipUploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            
            // Calculate overall progress: 90-100% for ZIP upload
            const overallPercent = Math.min(100, 90 + (zipUploadProgress * 10) / 100);
            setUploadProgress(Math.floor(overallPercent));
          },
          (error) => {
            reject(error);
          },
          () => {
            setUploadProgress(100);
            resolve();
          }
        );
      });

      // 4) getDownloadURL for zip to confirm existence
      let zipDownloadURL = "";
      try {
        zipDownloadURL = await getDownloadURL(zipRef);
      } catch (err) {
        // not fatal — still return path, but surface error
      }

      return {
        folderPath: encryptedFolderPath,
        filesUploaded: selectedDicomFolderFiles.length,
        zipFileName,
        zipPath: encryptData(zipStoragePath),
        zipDownloadURL: zipDownloadURL ? encryptData(zipDownloadURL) : "",
      };
    } catch (error) {
      // propagate so caller prints error and shows notification
      throw error;
    }
  };

  // Handle clinical history text
  const handleClinicalHistoryTextChange = (e) => {
    setClinicalHistoryText(e.target.value);
  };

  // Handle clinical history file upload
  const handleClinicalHistoryFileChange = (e) => {
    const file = e.target.files[0];
    const allowedExtensions = /(\.pdf|\.docx|\.txt)$/i;
    if (!allowedExtensions.test(file.name.toLowerCase())) {
      notifyError(
        "Invalid file type. Please upload a .pdf, .docx, or .txt file."
      );
      e.target.value = ""; // Clear the file input
      return;
    }
    setClinicalHistoryFile(file); // Set selected file
  };

  const uploadClinicalHistoryFile = async (patientKey) => {
    if (!clinicalHistoryFile) {
      return { filePath: "", downloadURL: "" }; // No file selected
    }
    // Define the file path in Firebase Storage
    const filePath = `superadmin/admins/${adminName1}/patients/${patientKey}/clinical_history/${clinicalHistoryFile.name}`;
    const fileRef = storageRef(storage, filePath);
    const uploadTask = uploadBytesResumable(fileRef, clinicalHistoryFile);
    setModalIsOpen(true); // Show the upload modal
    setUploadProgress(0); // Reset progress
    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadProgress(Math.floor(progress)); // Update progress
        },
        (error) => {
          reject(error);
        },
        async () => {
          try {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            setUploadProgress(100); // Progress Bar: Complete
            // resolve({ filePath, downloadURL });

            resolve({
              filePath: encryptData(filePath), // Encrypt the file path
              downloadURL: encryptData(downloadURL), // Encrypt the download URL
            });
          } catch (error) {
            reject(error);
          }
        }
      );
    });
  };

  // Increment upload count for the specific modality
  const incrementModalityUpload = async (modality) => {
    let modalityKey;
    switch (modality.toUpperCase()) {
      case "CT":
        modalityKey = "CTUploads";
        break;
      case "MRI":
        modalityKey = "MriUploads";
        break;
      case "XRAY":
        modalityKey = "XrayUploads"; // Capitalized "XrayUploads"
        break;
      default:
        return;
    }

    const modalityRef = dbRef(
      db,
      `superadmin/admins/${adminName1}/costing/${modalityKey}`
    );
    try {
      const snapshot = await get(modalityRef);
      const currentUploads = Number(snapshot.val()) || 0;
      await set(modalityRef, currentUploads + 1); // Increment the count
    } catch (error) {
      // Failed to increment modality count
    }
  };
  // Increment Total Uploads
  const incrementTotalUploads = async () => {
    const totalUploadsRef = dbRef(
      db,
      `superadmin/admins/${adminName1}/costing/TotalUpload`
    );
    try {
      const snapshot = await get(totalUploadsRef);
      const currentUploads = Number(snapshot.val()) || 0;
      await set(totalUploadsRef, currentUploads + 1); // Increment TotalUpload
    } catch (error) {
      // Failed to increment TotalUpload
    }
  };
  // Log Upload Events with Month-Year Structure
  const logUploadEvent = async (modality) => {
    const technicianName = localStorage.getItem("Name");
    const currentDate = new Date();
    const monthNames = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];
    const currentMonthYear = `${
      monthNames[currentDate.getMonth()]
    } ${currentDate.getFullYear()}`;
    const eventsPath = `superadmin/admins/${adminName1}/costing/Upload_Events/${currentMonthYear}`;
    const eventsRef = dbRef(db, eventsPath);

    try {
      const snapshot = await get(eventsRef);
      const nextIndex = snapshot.exists() ? snapshot.size : 0;

      const event = {
        TechnicianName: technicianName,
        PatientName: fullName,
        Modality: modality,
        Timestamp: `${String(currentDate.getDate()).padStart(2, "0")}/${String(
          currentDate.getMonth() + 1
        ).padStart(2, "0")}/${currentDate.getFullYear()}, ${String(
          currentDate.getHours()
        ).padStart(2, "0")}:${String(currentDate.getMinutes()).padStart(
          2,
          "0"
        )}:${String(currentDate.getSeconds()).padStart(2, "0")}`,
      };

      await set(dbRef(db, `${eventsPath}/${nextIndex}`), event);
    } catch (error) {
      // Failed to log upload event
    }
  };

  // Submit handler to process all form data and uploads
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!canSubmit) {
      return; // Stop form submission if invalid
    }

    // Check mandatory fields
    if (!fullName || !Id || !ageYears || !gender) {
      notifyError("Please fill all mandatory fields: Name, ID, Age, Gender.");
      return;
    }
    const sanitizeFirebaseKey = (key) => key.replace(/\//g, "_");

    const normalizeId = (id) => {
      const cleanedId = id.replace(/^P+/i, ""); // Remove all leading "P"s
      return `P${cleanedId}`; // Add exactly one "P" prefix
    };

    const normalizedId = normalizeId(Id); // Normalize user input ID
    const sanitizedFullName = sanitizeFirebaseKey(fullName);
    const patientKey = `${role}-${sanitizedFullName}`;
    const currentDate = new Date().toLocaleDateString("en-GB");
    const currentTimestamp = new Date().toISOString();
    const encryptedID = encryptData(normalizedId); // Encrypt normalized ID

    // Encrypt sensitive fields
    const encryptedFullName = encryptData(fullName);
    const formattedAge = ageMonths ? `${ageYears} Y ${ageMonths} M` : `${ageYears} years`;
    const encryptedAge = encryptData(formattedAge);
    const encryptedGender = encryptData(gender);
    // const encryptedID = encryptData("P" + Id);

    // Check for scan-related files
    const hasScanData =
      Dicom3D !== null ||
      (selectedDicomFolderFiles && selectedDicomFolderFiles.length > 0) ||
      selectedReportFile !== null;

    // 🔹 Step 1: Calculate total work and initialize progress
    const totalWorkBytes = calculateTotalUploadBytes();
    setTotalBytes(totalWorkBytes);
    resetProgressState();
    setModalIsOpen(true);
    
    console.log(`handleSubmit: Total upload work calculated: ${(totalWorkBytes / 1024 / 1024).toFixed(2)}MB`);

    // <<< Wallet check: If costing is Prepaid, verify sufficient wallet balance >>>
    if (costingType.toLowerCase() === "prepaid") {
      if (walletBalance < patientAddFee) {
        alert(
          "You do not have sufficient balance to add a patient , Contact Admin to Top-up wallet balance."
        );
        return;
      }
    }

    //Viniith Added
    setModalIsOpen(true);
    setUploadProgress(0);

    try {
      //  Check for duplicate patient ID
      const existingPatientsSnapshot = await get(
        dbRef(db, `superadmin/admins/${adminName1}/patients`)
      );

      if (existingPatientsSnapshot.exists()) {
        const patients = existingPatientsSnapshot.val();
        const isDuplicateID = Object.values(patients).some((patient) => {
          try {
            const decryptedID = decryptData(patient.ID);
            if (!decryptedID) {
              console.error("Failed to decrypt ID:", patient.ID);
              return false; // Skip invalid entries
            }
            const normalizedDecryptedID = normalizeId(decryptedID); // Normalize decrypted ID
            console.log(
              "Comparing:",
              normalizedDecryptedID,
              "with new ID:",
              normalizedId
            );
            return normalizedDecryptedID === normalizedId;
          } catch (error) {
            console.error("Error decrypting patient ID:", error);
            return false; // Skip malformed data
          }
        });

        if (isDuplicateID) {
          notifyError("This ID is already in use. Please choose a unique ID.");
          return; // Stop execution if duplicate found
        }
      }

      let dicom3DResult = { filePath: "", downloadURL: "" };
      let dicomFolderResult = { folderPath: "", filesUploaded: 0 };
      let reportResult = { filePath: "", downloadURL: "" };
      // let clinicalHistoryResult = { filePath: "", downloadURL: "" };
      // Upload DICOM 3D file
      if (Dicom3D) {
        dicom3DResult = await uploadDicom3DFile(patientKey);
      }

      // Upload Report File
      if (selectedReportFile) {
        reportResult = await uploadReportFile(patientKey);
      }

      // Upload DICOM Folder
      if (selectedDicomFolderFiles.length > 0) {
        dicomFolderResult = await uploadDicomFolder(patientKey);
      }

      let clinicalHistoryResult = { filePath: "", downloadURL: "" };
      // Upload Clinical History File
      if (clinicalHistoryFile) {
        clinicalHistoryResult = await uploadClinicalHistoryFile(patientKey);
      }

      const patientInfo = {
        FullName: encryptedFullName,
        ID: encryptedID,
        Role: role,
        DoctorAssigned: assignedHodDoctor ? [{
          name: assignedHodDoctor,
          assignedAt: formatDate(new Date()) // Add timestamp when HOD is assigned
        }] : [], // Store HOD assignment with timestamp
        Age: encryptedAge,
        Timestamp: currentTimestamp,
        Gender: encryptedGender,
        Version: "03",
        Addedby: techname && techname.trim() !== "" ? techname : "NA",
      };

      // Add clinical history fields only if clinical history is provided
      if (clinicalHistoryText || clinicalHistoryFile) {
        patientInfo.Clinical_Textarea = clinicalHistoryText || "";
        patientInfo.Clinical_Filepath = clinicalHistoryResult.downloadURL || "";
        patientInfo.Clinical_FilepathEncrypted =
          clinicalHistoryResult.filePath || "";
        patientInfo.Clinical_Timestamp = formatDate(new Date()); // Timestamp only for clinical history
      }

      // Save patient info only if it doesn't exist
      const patientExists = await get(
        dbRef(db, `superadmin/admins/${adminName1}/patients/${patientKey}`)
      );

      if (!patientExists.exists()) {
        await set(
          dbRef(db, `superadmin/admins/${adminName1}/patients/${patientKey}`),
          patientInfo
        );
      }

            // deepa audit logs: log patient creation by technician
            await logPatientCreationTech({ patientIdEncrypted: encryptedID, createdBy: techname || 'NA', patientName: fullName, uploaded3D: !!Dicom3D, uploadedReport: !!selectedReportFile, uploadedDicom: selectedDicomFolderFiles.length > 0, modality: modality ? modality.toUpperCase() : '', category: testType, clinicalHistoryEntered: !!clinicalHistoryText, clinicalHistoryFileAttached: !!clinicalHistoryFile, success: true });

      // Fetch existing uploads to determine the next key
      const uploadsRef = dbRef(
        db,
        `superadmin/admins/${adminName1}/patients/${patientKey}/uploads`
      );
      const uploadsSnapshot = await get(uploadsRef);

      const uploadCount = uploadsSnapshot.exists()
        ? Object.keys(uploadsSnapshot.val()).length + 1
        : 1;
      const uploadKey = `Scan ${uploadCount}`;

      // Prepare upload data
      const uploadData = {
        Dicom_3D: Dicom3D ? Dicom3D.name : "",
        Dicom_Report: selectedReportFile ? selectedReportFile.name : "", // Save report file name
        Path3D: dicom3DResult.filePath
          ? encryptData(dicom3DResult.filePath)
          : "",
        Dicom_3DURL: dicom3DResult.downloadURL
          ? encryptData(dicom3DResult.downloadURL)
          : "",
        FolderPath: dicomFolderResult.folderPath,
        PathReport: reportResult.filePath
          ? encryptData(reportResult.filePath)
          : "",

        Dicom_ReportURL: reportResult.downloadURL
          ? encryptData(reportResult.downloadURL)
          : "",
        // Type_of_Dicom_Data: `${selectedTest}`,
        Type_of_Dicom_Data: testType, // Use testType here

        Modality: modality ? modality.toUpperCase() : "",

        // StudyDate: selectedDicomFolderFiles.length > 0 ? currentDate : null, // Use null if no folder
        StudyDate: selectedDicomFolderFiles.length > 0 ? currentDate : "", // Always include StudyDate
        //  uplaodtimetamp: currentTimestamp,
        uplaodtimetamp: hasScanData ? currentTimestamp : "", // Set empty if no scan data
      };

      //    // Save patient and uploads data
      await set(
        dbRef(
          db,
          `superadmin/admins/${adminName1}/patients/${patientKey}/uploads/${uploadKey}`
        ),
        uploadData
      );
      // Increment upload counts and log events only if a folder scan was uploaded
      if (selectedDicomFolderFiles.length > 0) {
        await incrementTotalUploads();
        if (modality) await incrementModalityUpload(modality);
        await logUploadEvent(modality);
      }

      // vinith added 19feb
      // Calculate the total storage size of uploaded files
      const newUploadSize = await calculateTotalStorageSize();

      // Update AdminStorageSize in Firebase
      if (newUploadSize) {
        const adminStorageRef = dbRef(
          db,
          `superadmin/admins/${adminName1}/AdminStorageSize`
        );
        try {
          await set(adminStorageRef, newUploadSize);
        } catch (error) {
          // Failed to update AdminStorageSize
        }

        try {
          const adminStorageSnapshot = await get(adminStorageRef);
          if (adminStorageSnapshot.exists()) {
            const updatedStorageSize = newUploadSize;
            await set(adminStorageRef, updatedStorageSize);
          } else {
            await set(adminStorageRef, newUploadSize);
          }
        } catch (error) {
          // Failed to update AdminStorageSize
        }
      }

      // <<< Wallet Deduction: If Prepaid, deduct fee and log transaction >>>
      if (costingType.toLowerCase() === "prepaid") {
        const updatedBalance = walletBalance - patientAddFee;
        const walletRef = dbRef(
          db,
          `superadmin/admins/${adminName1}/Wallet/Wallet_Balance`
        );
        await set(walletRef, updatedBalance);
        setWalletBalance(updatedBalance);

        const getMonthYearLabel = () => {
          const date = new Date();
          const monthNames = [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ];
          const month = monthNames[date.getMonth()];
          const year = date.getFullYear();
          return `${month} ${year}`;
        };

        const currentMonthYear = getMonthYearLabel();
        const walletTxPath = `superadmin/admins/${adminName1}/Wallet/Wallet_Transactions/${currentMonthYear}`;
        const txSnapshot = await get(dbRef(db, walletTxPath));
        const nextIndex = txSnapshot.exists()
          ? Object.keys(txSnapshot.val()).length
          : 0;
        const transaction = {
          AddedBy: techname || "Unknown Technician",
          PatientName: fullName,
          PatientID: Id,
          AmountDeducted: patientAddFee,
          UpdatedBalance: updatedBalance,
          Timestamp: new Date().toLocaleString("en-GB"),
        };
        await set(dbRef(db, `${walletTxPath}/${nextIndex}`), transaction);
      }

      notifySuccess("Patient added successfully.");
      setTimeout(() => navigate("/Technician"), 2000);
    } catch (error) {
      notifyError("Failed to add patient. Please try again.");
    } finally {
      setModalIsOpen(false);
    }
  };

  //Viniith Added 31-01-2024
  const calculateTotalStorageSize = async () => {
    let totalSize = 0;

    // 1. Sum up the sizes of the newly uploaded files
    if (Dicom3D) {
      totalSize += Dicom3D.size;
    }

    if (selectedReportFile) {
      totalSize += selectedReportFile.size;
    }

    if (clinicalHistoryFile) {
      totalSize += clinicalHistoryFile.size;
    }

    if (selectedDicomFolderFiles?.length > 0) {
      selectedDicomFolderFiles.forEach((file) => {
        totalSize += file.size;
      });
    }

    // 2. Get the existing storage from Firebase
    const adminStorageRef = dbRef(
      db,
      `superadmin/admins/${adminName1}/AdminStorageSize`
    );
    let currentStorageSize = 0;

    try {
      const adminStorageSnapshot = await get(adminStorageRef);
      if (adminStorageSnapshot.exists()) {
        const storedSize = adminStorageSnapshot.val();
        // Convert stored size to bytes
        currentStorageSize = parseFormattedSizeToBytes(storedSize);
      }
    } catch (error) {
      // Error fetching AdminStorageSize
    }

    // 3. Add the new uploaded size to the existing storage size
    const updatedStorageSizeBytes = currentStorageSize + totalSize;

    // 4. Convert to human-readable format
    const humanReadableSize = formatFileSize(updatedStorageSizeBytes);

    // Return the human-readable format for wherever you need to store or display it
    return humanReadableSize;
  };

  // Utility: format bytes -> human-readable string
  const formatFileSize = (size) => {
    if (size < 1024) return `${size}B`; // bytes
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)}KB`; // KB
    if (size < 1024 * 1024 * 1024)
      return `${(size / (1024 * 1024)).toFixed(2)}MB`; // MB
    return `${(size / (1024 * 1024 * 1024)).toFixed(2)}GB`; // GB
  };

  const parseFormattedSizeToBytes = (formatted) => {
    // Remove any spaces between the number and the unit
    const normalized = formatted.replace(/\s+/g, ""); // Remove all whitespace
    const sizePattern = /^(\d+(\.\d+)?)(KB|MB|GB|B)$/i; // Match without spaces
    const match = normalized.match(sizePattern);

    if (!match) {
      return 0;
    }

    const value = parseFloat(match[1]); // e.g., 2, 4.53
    const unit = match[3].toUpperCase(); // e.g., "MB", "KB"

    switch (unit) {
      case "B":
        return value;
      case "KB":
        return value * 1024;
      case "MB":
        return value * 1024 * 1024;
      case "GB":
        return value * 1024 * 1024 * 1024;
      default:
        return 0;
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("adminName");
    navigate("/");
  };

  return (
    <>
      {/* Sidebar for navigation or additional options */}
      <div className="techsidebar-modified"></div>

      {/* ✅ Top Panel with Logout Dropdown */}
      <div className="top-nav-modified">
        <Dropdown className="ml-auto">
          <Dropdown.Toggle variant="secondary" id="dropdown-basic">
            {techname || "User"}
          </Dropdown.Toggle>
          <Dropdown.Menu className="logout-menu">
            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div>
        {/* Main content section */}
        <h2 className="text-center h2addpatient">Patient Enrollment</h2>

        <Link to="/Technician" className="homeButton">
          <span id="backText" className="backText">
            Back
          </span>
          <i
            id="backIcon"
            className="fas fa-long-arrow-alt-left fa-lg fa-1x"
          ></i>
        </Link>
        <form className="addPatientForm" onSubmit={handleSubmit}>
          <div className="row">
            <div className="column">
              <strong className="strongaddpatient">
                Name
                <span className="required" style={{ color: "red" }}>
                  *
                </span>
              </strong>
              <input
                className="inputaddadmin"
                type="text"
                placeholder="Full Name"
                maxLength="25"
                title="Only letters and spaces allowed (Max 25 characters)"
                value={fullName}
                onChange={(e) => {
                  const value = e.target.value;
                  setFullName(value);
                  setCanSubmit(!/\d/.test(value) && value.trim().length > 0); // Enable only if valid
                }}
                required
                style={{
                  borderColor: /\d/.test(fullName) ? "red" : "",
                }}
              />
              {/* Show warning message in red if the user types numbers */}
              {/\d/.test(fullName) && (
                <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                  Only alphabets are allowed.
                </p>
              )}
              {/* Show notification when the limit is reached */}
              {fullName.length === 25 && (
                <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                  You have reached the 25-character limit.
                </p>
              )}
            </div>

            {/* Age */}
            <div className="column">
              <strong className="strongaddpatient">
                Age
                <span className="required" style={{ color: "red" }}>
                  *
                </span>
              </strong>
              <div className="age-input-container" style={{ display: "flex", gap: "10px" }}>
                <div style={{ flex: 1 }}>
                  <input
                    type="number"
                    className="inputaddadmin"
                    placeholder="Years"
                    min="0"
                    max="150"
                    value={ageYears}
                    onChange={(e) => setAgeYears(e.target.value)}
                    required
                    style={{
                      borderColor: (ageYears && (parseInt(ageYears) < 0 || parseInt(ageYears) > 150)) ? "red" : "",
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <input
                    type="number"
                    className="inputaddadmin"
                    placeholder="Months"
                    min="0"
                    max="11"
                    value={ageMonths}
                    onChange={(e) => setAgeMonths(e.target.value)}
                    style={{
                      borderColor: (ageMonths && (parseInt(ageMonths) < 0 || parseInt(ageMonths) > 11)) ? "red" : "",
                    }}
                  />
                </div>
              </div>
              {/* Age validation message */}
              {((ageYears && (parseInt(ageYears) < 0 || parseInt(ageYears) > 150)) || 
                (ageMonths && (parseInt(ageMonths) < 0 || parseInt(ageMonths) > 11))) && (
                <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                  Please enter valid age (0-150 years, 0-11 months)
                </div>
              )}
            </div>
          </div>

          {/* Gender */}
          <div className="row">
            <div className="column">
              <strong className="strongaddpatient">
                Gender
                <span className="required" style={{ color: "red" }}>
                  *
                </span>
              </strong>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                options={[
                  { value: "Male", label: "Male" },
                  { value: "Female", label: "Female" },
                  { value: "Other", label: "Other" }
                ]}
                value={gender ? { value: gender, label: gender } : null}
                onChange={(selectedOption) => setGender(selectedOption ? selectedOption.value : "")}
                placeholder="Select Gender"
                isClearable
              />
            </div>
            <div className="column">
              <strong className="strongaddpatient">
                ID
                <span className="required" style={{ color: "red" }}>
                  *
                </span>
              </strong>
              <input
                className="inputaddadmin"
                placeholder="ID"
                onChange={(e) => setID(e.target.value)}
                required
                type="text"
              />
            </div>
          </div>

          <div className="row">
            <div className="column">
              {/* Dropdown for selecting modality */}
              <strong className="strongaddpatient">Modality</strong>
              <select
                className="inputaddadmin"
                value={modality}
                onChange={(e) => setModality(e.target.value)}
                // required
              >
                <option value="">Select</option>
                <option value="CT">CT</option>
                <option value="MRI">MRI</option>
                <option value="XRAY">X-Ray</option>
              </select>
            </div>

            <div className="column">
              {/* Dropdown for selecting test type or entering custom test */}
              <strong className="strongaddpatient">
                Category
                {/* Viniith Fix this 05-08-2025 - Show required asterisk when modality is selected */}
                {modality.trim() !== "" && (
                  <span className="required" style={{ color: "red" }}>
                    *
                  </span>
                )}
              </strong>
              <select
                className="inputaddadmin"
                value={selectedTest}
                disabled={modality.trim() === ""} // Viniith Fix this 05-08-2025 - Disable when no modality
                onChange={(e) => {
                  setSelectedTest(e.target.value); // Update dropdown value
                  if (e.target.value !== "Other") {
                    setTestType(e.target.value); // Set testType to dropdown value
                  } else {
                    setTestType(""); // Clear testType for custom input
                  }
                }}
                style={{
                  backgroundColor: modality.trim() === "" ? "#f5f5f5" : "",
                  cursor: modality.trim() === "" ? "not-allowed" : "pointer"
                }}
              >
                {/* <option value="" disabled>Test Type</option> */}
                <option value="">Test Type</option>
                {(testNames[modality] || []).map((test, index) => (
                  <option key={index} value={test}>
                    {test}
                  </option>
                ))}
                {modality.trim() !== "" && <option value="Other">Other</option>}
              </select>
              
              {/* Viniith Fix this 05-08-2025 - Helper message when modality not selected */}
              {modality.trim() === "" && (
                <p style={{ color: "#666", fontSize: "12px", marginTop: "5px", fontStyle: "italic" }}>
                  Please select a Modality first to choose Category
                </p>
              )}

              {/* Show input for custom test type if "Other" is selected */}
              {selectedTest === "Other" && (
                <div style={{ marginTop: "10px" }}>
                  <input
                    className="inputaddpatient"
                    type="text"
                    placeholder="Enter Custom Test Type"
                    value={testType}
                    onChange={(e) => setTestType(e.target.value)}
                    required
                  />
                </div>
              )}
            </div>
          </div>
          {/* Section for entering clinical history */}
          <div className="column">
            <strong className="strongaddpatient">Clinical History</strong>
            <div className="textarea-wrapper">
              <textarea
                className="inputaddpatient"
                placeholder="Enter Clinical History"
                value={clinicalHistoryText}
                onChange={handleClinicalHistoryTextChange}
              />
              {/* File upload input for clinical history */}

              <input
                type="file"
                id="clinicalHistoryFileInput"
                className="hidden-input"
                accept=".pdf,.docx,.txt"
                onChange={handleClinicalHistoryFileChange}
              />

              {/* Show File Name & ❌ Instead of 📎 When a File is Attached */}
              {clinicalHistoryFile ? (
                <div className="file-display">
                  <span className="file-name">{clinicalHistoryFile.name}</span>
                  <button
                    className="remove-file-btn"
                    onClick={() => {
                      setClinicalHistoryFile(null);
                      document.getElementById(
                        "clinicalHistoryFileInput"
                      ).value = ""; // Reset input field
                    }}
                  >
                    ❌
                  </button>
                </div>
              ) : (
                // Show Attach File Icon if No File is Selected
                <label
                  htmlFor="clinicalHistoryFileInput"
                  className="attach-file-icon"
                  title="Attach File"
                >
                <i className="fas fa-paperclip"></i>
                </label>
              )}
            </div>
          </div>

          {/* File upload section */}
          <div className="file-upload-row">
            {/* 3D File Upload - COMMENTED OUT */}
            {/* <div className="file-upload-column">
              <label className="file-upload-label">3D</label>
              <div className="file-upload-input">
                <button
                  type="button"
                  className="choose-file-btn"
                  title="Choose file"
                  onClick={() => file3DInputRef.current.click()}
                >
                  <i className="fas fa-file-upload"></i>
                </button>
                <span className="file-name-display">
                  {selected3DFileName ? (selected3DFileName.length > 5 ? `${selected3DFileName.slice(0,5)}...` : selected3DFileName) : "No file selected"}
                </span>
                <input
                  type="file"
                  ref={file3DInputRef}
                  className="hidden-file-input"
                  accept=".gltf,.glb"
                  onChange={handleFileChange}
                />
                {selected3DFileName && (
                  <button
                    type="button"
                    className="remove-file-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDicom3D(null);
                      setSelected3DFileName("");
                      file3DInputRef.current.value = "";
                    }}
                  >
                    ❌
                  </button>
                )}
              </div>
            </div> */}
            {/* Scan (Image File) Upload */}
            <div className="file-upload-column">
              <label className="file-upload-label">Scan</label>
              <div className="file-upload-input">
                <button
                  type="button"
                  className="choose-file-btn"
                  title="Choose file"
                  onClick={() => folderInputRef.current.click()}
                >
                  <i className="fas fa-file-upload"></i>
                </button>
                <span className="file-name-display">
                  {selectedFolderName ? (selectedFolderName.length > 15 ? `${selectedFolderName.slice(0,15)}...` : selectedFolderName) : "No file selected"}
                </span>
                <input
                  type="file"
                  ref={folderInputRef}
                  className="hidden-file-input"
                  accept=".png,.jpg,.jpeg,.dcm"
                  webkitdirectory=""
                  onChange={handleSingleScanFileChange}
                />
                {selectedFolderName && (
                  <button
                    type="button"
                    className="remove-file-btn"
                    onClick={removeDicomFolder}
                  >
                    ❌
                  </button>
                )}
              </div>
            </div>
            {/* Report File Upload */}
            <div className="file-upload-column">
              <label className="file-upload-label">Report</label>
              <div className="file-upload-input">
                {/* deepa: moved onClick from wrapper to the button below */}
                <button
                  type="button"
                  className="choose-file-btn"
                  title="Choose report"
                  onClick={() => reportFileInputRef.current.click()} // deepa added here
                >
                  <i className="fas fa-file-upload"></i>
                </button>
                <span className="file-name-display">
                  {selectedReportFileName ? (selectedReportFileName.length > 5 ? `${selectedReportFileName.slice(0,5)}...` : selectedReportFileName) : "No file selected"} {/* Viniith Fix name issue */}
                </span>

                <input
                  type="file"
                  ref={reportFileInputRef}
                  className="hidden-file-input"
                  accept=".pdf,.docx,.txt"
                  onChange={handleReportFileChange}
                />

                {selectedReportFileName && (
                  <button
                    type="button"
                    className="remove-file-btn"
                    onClick={removeReportFile}
                  >
                    ❌
                  </button>
                )}
              </div>
            </div>                 
          </div>

          {/* Submit button */}
          <button
            className="addpatientbtn"
            disabled={!canSubmit}
            style={{
              backgroundColor: !canSubmit ? "#b0b0b0" : "", // Grey when disabled
              cursor: !canSubmit ? "not-allowed" : "pointer",
            }}
            title={!canSubmit ? "Please Fill Out Form" : ""}
          >
            ADD
          </button>
          <ToastContainer />
        </form>
      </div>
      <div>
        <ChatNot />
      </div>

      {/* Modal for showing upload progress */}
      {/* {Viniith Added} */}
      {modalIsOpen && (
        <div className="modal-overlay">
          <div className="modalUpload">
            <h2>Uploading...</h2>
            <div className="modal-upload-progress">
              <div
                className="bar"
                style={{ width: `${uploadProgress}%` }}
              ></div>
            </div>
            <div className="progress-info">
              <span className="progress-percent">{uploadProgress}%</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddPatientTech;
